import React from 'react'
import { Image } from "semantic-ui-react";

export const GetMember = () => {
    return (
        <span>
            <h2>Mitglied werden</h2>

            Du möchtest Mitglied werden. Dann melde ich direkt online an!

            <Image
                className="centeredImage"
                src="/assets/QRMitgliedsantrag.jpg"
                size="medium"
                 />

            <h3>Oder ihr nutzt Link: <a href="https://finnigans.webling.eu/forms/memberform/9f122e663b6efe7dc3a1" target="_blank" rel="noopener noreferrer">Zum Mitgliederantrag</a></h3>
        </span>)
}
        